import withScroll from '../hoc/withScroll'
import onResize from '../utils/onResize'
import { get } from '@bigyouth/base'

export default withScroll({
  name: 'sticky-button',

  ui: {
  },

  events: [],

  componentDidMount () {
    this.off = onResize(this.onResize.bind(this))
    this.calc()
  },

  componentWillUnmount () {
    this.off()
  },

  calc () {
    this.buttonOffset = this.el.parentNode.offsetTop + 130
    this.bottomSize = get('.app-footer').offsetHeight +
      (get('.slice-newsletter') ? get('.slice-newsletter').offsetHeight : 0)
    this.docHeight = document.body.clientHeight
  },

  onResize () {
    this.calc()
  },

  onScroll ({ y }) {
    if (window.innerWidth >= 1024) {
      if (y > this.buttonOffset + this.el.offsetHeight) {
        this.el.classList.add('is-sticky')

        if (y + window.innerHeight >= this.docHeight - this.bottomSize) {
          this.el.classList.remove('is-visible')
        } else {
          setTimeout(() => {
            this.el.classList.add('is-visible')
          }, 100)
        }
      } else {
        this.el.classList.remove('is-sticky')
      }
    } else {
      if (y + window.innerHeight >= this.docHeight - this.bottomSize) {
        this.el.classList.add('is-hidden')
      } else {
        this.el.classList.remove('is-hidden')
      }
    }
  },
})
